var classof   = require('./$.classof')
  , ITERATOR  = require('./$.wks')('iterator')
  , Iterators = require('./$.iterators');
module.exports = require('./$.core').getIteratorMethod = function(it){
  if(it != undefined)return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/*****************
 ** WEBPACK FOOTER
 ** /Users/nw/flint/flintjs-deps/~/core-js/library/modules/core.get-iterator-method.js
 ** module id = 47
 ** module chunks = 2
 **/